export const ENTITY_ID = "entityId";
export const ENTITY_TYPE = "entityType";
export const DESCRIPTION = "fileDescription";
export const FILE = "file";
export const UPLOADED_FILES = "uploadedFiles";